import { useT } from '@/lib/i18n';
import { DOWNLOAD_NAME, documentCopy, documentUrl } from './document-file';
import { DocumentIcon } from './DocumentIcon';

/**
 * The catalogue PDF as a small card, for the places a phone visitor can reach without a strip over the logo: the
 * full-screen menu and the footer (D-360). Same file and words as the navbar's download icon (`DownloadLink`); the buttons are 44 px tall.
 */
export function DocumentCard({ onNavigate }: { onNavigate?: () => void }) {
  const copy = documentCopy;
  const t = useT();
  return (
    <div className="document-card" role="group" aria-label={copy.region}>
      <span className="document-card__icon" aria-hidden="true">
        <DocumentIcon />
      </span>
      <span className="document-card__text">
        <strong className="document-card__label">{copy.label}</strong>
        <span className="document-card__note">{copy.note}</span>
      </span>
      <span className="document-card__actions">
        <a
          className="document-card__button document-card__button--ghost"
          href={documentUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onNavigate}
        >
          {copy.view}
          <span className="sr-only"> {t('common.opensInNewTab')}</span>
        </a>
        <a
          className="document-card__button"
          href={documentUrl}
          download={DOWNLOAD_NAME}
          onClick={onNavigate}
        >
          {copy.download}
        </a>
      </span>
    </div>
  );
}
